<template>
  <v-container fluid>
    <v-row>
      <v-col>
        {{ $t('admin_acc_gym_subscription_type.title') }}
      </v-col>
      <v-col class="text-right">
        <v-menu v-model="addSubscriptionTypeMenuOpened"
                :close-on-content-click="false"
                left
                offset-x>
          <template v-slot:activator="{on, attrs}">
            <v-btn small
                   v-bind="attrs"
                   v-on="on">
              <v-icon>fas fa-plus</v-icon>
            </v-btn>
          </template>

          <v-card outlined>
            <v-card-title>{{ $t('admin_acc_gym_subscription_type.add_title') }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-text-field outlined
                                :label="$t('admin_acc_gym_subscription_type.name_en')"
                                :placeholder="$t('admin_acc_gym_subscription_type.name_en')"
                                v-model="addingSubscriptionTypeNameEn">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field outlined
                                :label="$t('admin_acc_gym_subscription_type.name_zh')"
                                :placeholder="$t('admin_acc_gym_subscription_type.name_zh')"
                                v-model="addingSubscriptionTypeNameZh">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="#2bc7ca"
                     @click="addSubscriptionTypeMenuOpened = false">
                {{ $t('cancel') }}
              </v-btn>
              <v-btn text color="#2bc7ca"
                     @click="addSubscriptionType">
                {{ $t('save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table :items="subscriptionTypes"
                      :headers="subscriptionTypeHeaders"
                      hide-default-footer>
          <template v-slot:item.actions="data">
            <font-awesome-icon icon="edit"
                               class="mr-3"
                               @click.stop="editSubscriptionType(data.item)"></font-awesome-icon>
            <font-awesome-icon icon="trash"
                               @click.stop="deleteSubscriptionType(data.item)"></font-awesome-icon>
          </template>
        </v-data-table>
      </v-col>
      <v-col v-if="editingSubscriptionType">
        <v-row>
          <v-col>{{ $t('admin_acc_gym_subscription_type.edit_title') }}</v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field outlined
                          :label="$t('admin_acc_gym_subscription_type.name_en')"
                          :placeholder="$t('admin_acc_gym_subscription_type.name_en')"
                          v-model="editingSubscriptionType.name_en">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field outlined
                          :label="$t('admin_acc_gym_subscription_type.name_zh')"
                          :placeholder="$t('admin_acc_gym_subscription_type.name_zh')"
                          v-model="editingSubscriptionType.name_zh">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <b-form-group :label="$t('admin_acc_gym_subscription_type.description_en')"
                          horizontal>
              <TinyMceEditor v-model="editingSubscriptionType.description_en"></TinyMceEditor>
            </b-form-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <b-form-group :label="$t('admin_acc_gym_subscription_type.description_zh')"
                          horizontal>
              <TinyMceEditor v-model="editingSubscriptionType.description_zh"></TinyMceEditor>
            </b-form-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field outlined
                          :label="$t('admin_acc_gym_subscription_type.price')"
                          :placeholder="$t('admin_acc_gym_subscription_type.price')"
                          v-model="editingSubscriptionType.price">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox :label="$t('admin_acc_gym_subscription_type.can_reserve')"
                        :placeholder="$t('admin_acc_gym_subscription_type.can_reserve')"
                        v-model="editingSubscriptionType.can_reserve">
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field outlined
                          :label="$t('admin_acc_gym_subscription_type.valid_for_uses')"
                          :placeholder="$t('admin_acc_gym_subscription_type.valid_for_uses')"
                          v-model="editingSubscriptionType.valid_for_uses"
                          type="number"
                          min="-1">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field outlined
                          :label="$t('admin_acc_gym_subscription_type.valid_for_days')"
                          :placeholder="$t('admin_acc_gym_subscription_type.valid_for_days')"
                          v-model="editingSubscriptionType.valid_for_days">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-right">
            <v-btn color="#dddddd" @click="editingSubscriptionType = null" class="mr-3">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn color="#2bc7ca" @click="saveSubscriptionType">
              {{ $t('save') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {onMounted, ref} from '@vue/composition-api';
import TinyMceEditor from "@/components/TinyMceEditor";

export default {
  name: 'GymSubscriptionTypeList',
  components: {TinyMceEditor},
  setup(props, {root}) {
    const subscriptionTypes = ref([])
    const getSubscriptionTypes = function () {
      root.$callAPI('aafb/gym_subscription/types/', {}, function (response) {
        subscriptionTypes.value = response.body.subscription_types;
      });
    };
    const subscriptionTypeHeaders = [
      {text: root.$t('admin_acc_gym_subscription_type.name_en'), value: 'name_en'},
      {text: root.$t('admin_acc_gym_subscription_type.name_zh'), value: 'name_zh'},
      // {text: root.$t('admin_acc_gym_subscription_type.price'), value: 'price'},
      // {text: root.$t('admin_acc_gym_subscription_type.valid_for_days'), value: 'valid_for_days'},
      {text: '', value: 'actions', align: 'end'},
    ];

    const addSubscriptionTypeMenuOpened = ref(false);
    const addingSubscriptionTypeNameEn = ref('');
    const addingSubscriptionTypeNameZh = ref('');
    const addingSubscriptionTypePrice = ref(0);
    const addingSubscriptionTypeValidForDays = ref(1);
    const addSubscriptionType = function () {
      root.$callAPI('aafb/admin/gym_subscription/type/set/', {
        name_en: addingSubscriptionTypeNameEn.value,
        name_zh: addingSubscriptionTypeNameZh.value,
        // price: addingSubscriptionTypePrice.value,
        // valid_for_days: addingSubscriptionTypeValidForDays.value,
      }, function (response) {
        addSubscriptionTypeMenuOpened.value = false;
        addingSubscriptionTypeNameEn.value = '';
        addingSubscriptionTypeNameZh.value = '';
        // addingSubscriptionTypePrice.value = 0;
        // addingSubscriptionTypeValidForDays.value = 1;
        getSubscriptionTypes();
      });
    };

    const editingSubscriptionType = ref(null);
    const editSubscriptionType = function (item) {
      editingSubscriptionType.value = item;
    };

    const deleteSubscriptionType = function (item) {
      if (confirm(root.$t('admin_acc_gym_subscription_type.confirm_delete'))) {
        root.$callAPI('aafb/admin/gym_subscription/type/delete/', {
          type_id: item.id,
        }, function (response) {
          getSubscriptionTypes();
        });
      }
    };
    const saveSubscriptionType = function () {
      root.$callAPI('aafb/admin/gym_subscription/type/set/', {
        type_id: editingSubscriptionType.value.id,
        name_en: editingSubscriptionType.value.name_en,
        name_zh: editingSubscriptionType.value.name_zh,
        description_en: editingSubscriptionType.value.description_en,
        description_zh: editingSubscriptionType.value.description_zh,
        price: editingSubscriptionType.value.price,
        can_reserve: editingSubscriptionType.value.can_reserve,
        valid_for_uses: editingSubscriptionType.value.valid_for_uses,
        valid_for_days: editingSubscriptionType.value.valid_for_days,
      }, function (response) {
        editingSubscriptionType.value = null;
        getSubscriptionTypes();
      });
    };

    onMounted(() => {
      getSubscriptionTypes();
    })


    return {
      subscriptionTypes,
      subscriptionTypeHeaders,

      addSubscriptionTypeMenuOpened,
      addingSubscriptionTypeNameEn,
      addingSubscriptionTypeNameZh,
      addingSubscriptionTypePrice,
      addingSubscriptionTypeValidForDays,
      addSubscriptionType,

      editingSubscriptionType,
      editSubscriptionType,
      deleteSubscriptionType,
      saveSubscriptionType,
    };
  }
}
</script>
